import React, { useState, useEffect } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import { FaAngleDown } from 'react-icons/fa';

import { getFormattedCurrency } from '~/utils';

import api from '~/services/api';

import InfoInput from '~/components/Inputs/Info';

import { MainContainer, Label, Container } from './styles';

interface IRebateMovementProps {
  project_id: string;
  default_expanded?: boolean;
}

const RebateMovement: React.FC<IRebateMovementProps> = ({
  project_id,
  default_expanded,
}) => {
  const [movement, setMovement] = useState<{
    price: number;
    project: {
      code: string;
    };
    rebate_balance: {
      total_price: number;
      used_price: number;
      pending_price: number;
    };
    quarter: {
      code: string;
    };
    policy_group: {
      name: string;
    };
  }>();

  useEffect(() => {
    const fetchRebateMovement = async () => {
      api
        .get(`/rebatemovements/project?project_id=${project_id}`)
        .then(response => {
          setMovement(response.data);
        });
    };

    fetchRebateMovement();
  }, [project_id]);

  return (
    <MainContainer>
      <Accordion defaultExpanded={default_expanded}>
        <AccordionSummary expandIcon={<FaAngleDown />}>
          <Label>Movimento de Rebate</Label>
        </AccordionSummary>

        <AccordionDetails>
          <Container>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
              <div style={{ width: 195 }}>
                <InfoInput
                  name="project_code"
                  labelFor="project_code"
                  labelText="Código da Solicitação"
                  type="text"
                  value={movement?.project.code}
                  disabled
                />
              </div>

              <div style={{ width: 195 }}>
                <InfoInput
                  name="price"
                  labelFor="price"
                  labelText="Valor do Movimento"
                  type="text"
                  value={movement && getFormattedCurrency(movement.price)}
                  disabled
                />
              </div>

              <div style={{ width: 195 }}>
                <InfoInput
                  name="quarter"
                  labelFor="quarter"
                  labelText="Trimestre"
                  type="text"
                  value={movement?.quarter.code}
                  disabled
                />
              </div>

              <div style={{ width: 195 }}>
                <InfoInput
                  name="policy_group"
                  labelFor="policy_group"
                  labelText="Grupo de Política Comercial"
                  type="text"
                  value={movement?.policy_group.name}
                  disabled
                />
              </div>

              <div style={{ width: 195 }}>
                <InfoInput
                  name="balance_total_price"
                  labelFor="balance_total_price"
                  labelText="Valor Total Grupo"
                  type="text"
                  value={
                    movement &&
                    getFormattedCurrency(movement.rebate_balance.total_price)
                  }
                  disabled
                />
              </div>

              <div style={{ width: 195 }}>
                <InfoInput
                  name="balance_used_price"
                  labelFor="balance_used_price"
                  labelText="Valor Usado Grupo"
                  type="text"
                  value={
                    movement &&
                    getFormattedCurrency(movement.rebate_balance.used_price)
                  }
                  disabled
                />
              </div>

              <div style={{ width: 195 }}>
                <InfoInput
                  name="balance_pending_price"
                  labelFor="balance_pending_price"
                  labelText="Valor Pendente Grupo"
                  type="text"
                  value={
                    movement &&
                    getFormattedCurrency(movement.rebate_balance.pending_price)
                  }
                  disabled
                />
              </div>
            </div>
          </Container>
        </AccordionDetails>
      </Accordion>
    </MainContainer>
  );
};

export default RebateMovement;
